import { usePathname } from 'next/navigation';
import { useMemo } from 'react';
import {
	getCurrentSiteSectionId,
	getCurrentSiteSectionSlug,
} from '../../../navigation/utils/getCurrentSiteSectionDetails';
import { websiteTag } from '../../../../../types/siteSectionSearchTag';
import { createContentSearchStore } from '../../../../../features/content-search/domain/stores/createContentSearchStore';
import { algoliaSearchService } from '../../../../../features/content-search/data/services';

export function useCreateUnifiedSearchInformationStore() {
	const pathname = usePathname();
	const siteSectionIdFromSlug = getCurrentSiteSectionId(pathname);
	const currSiteSectionSlug = getCurrentSiteSectionSlug(siteSectionIdFromSlug);
	const { tag } = websiteTag[currSiteSectionSlug];
	const informationStore = useMemo(
		() =>
			createContentSearchStore({
				algoliaSearchService,
				websiteTag: tag,
				offset: 20,
			}),
		[tag],
	);

	return informationStore;
}
